import { Box, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import dayjs from "dayjs";
import ComCalenderIcon from "../ui/Icons/ComCalenderIcon";
import { setCheck } from "../redux-toolkit/slices/cleared.published.slice";
import { useAppDispatch } from "../hooks/useAppDispatch";
import CalenderArrowPrev from "../ui/Icons/CalenderArrowPrev";
import CalenderArrowNext from "../ui/Icons/CalenderArrowNext";

const useHandleOutsideClick = (onOutsideClick, onInsideClick) => {
  const ref = React.useRef();
  React.useEffect(() => {
    let clicked = false;
    const handleOutsideClick = (e) => {
      if (clicked) {
        clicked = false;
        return;
      }
      if (onOutsideClick) {
        onOutsideClick(e);
      }
    };
    const handleInsideClick = (e) => {
      clicked = true;
      if (onInsideClick) {
        onInsideClick(e);
      }
    };
    const component = ref.current;
    window.addEventListener("click", handleOutsideClick);
    if (component) {
      component.addEventListener("click", handleInsideClick);
    }
    return () => {
      window.addEventListener("click", handleOutsideClick);
      if (component) {
        component.addEventListener("click", handleInsideClick);
      }
    };
  }, []);
  return ref;
};

const CalenderDateThree = ({ calenderFilter, confirmCalender }) => {
  const [values, setValues] = useState([null, null]);
  // const [values, setValues] = useState([new Date().setDate(0), new Date()]);
  const [calValues, setCalValues] = useState([null, null]);
  const dispatch = useAppDispatch();

  // console.log("calValues", calValues);
  // console.log("values", values);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [calenderOpen, calenderClose] = React.useState(false);
  const handleclicker = () => {
    calenderClose(!calenderOpen);
  };

  const handleOutsideClick = () => {
    calenderClose(false);
    setValues([null, null]);
    setCalValues([null, null]);
  };
  const ref = useHandleOutsideClick(handleOutsideClick);

  const handleButtonClick = (event) => {
    event.stopPropagation();
  };
  const leftCalenderRef = useRef();
  const rightCalenderRef = useRef();

  // function update(key, value) {
  // function update(key, value) {
  //   // let date = leftCalenderRef.current.date;
  //   // console.log("date", date, date[key]);

  //   leftCalenderRef.current.set(key, date[key] - value);
  // }

  const [maxDateLeft, setMaxDateLeft] = useState(new Date().setDate(0));
  // console.log("maxDateLeft", maxDateLeft);
  function minusDateRight(month) {
    // console.log("month", month, month - 1);
    // console.log(
    //   "new Date().setMonth(month - 2)",
    //   new Date().setMonth(month - 2)
    // );
    // console.log("call minus");
    // let date = leftCalenderRef.current.date;
    // console.log("date", date, date[key]);
    setMaxDateLeft(new Date().setMonth(month - 1, 0));
    leftCalenderRef.current.set("month", month - 1);
  }
  function minusDateLeft(month) {
    // console.log("month", month, month - 1);
    // console.log(
    //   "new Date().setMonth(month - 2)",
    //   new Date().setMonth(month - 2)
    // );
    // console.log("call minus");
    // let date = leftCalenderRef.current.date;
    // console.log("date", date, date[key]);
    // setMaxDateLeft(new Date().setMonth(month - 1, 0));
    rightCalenderRef.current.set("month", month + 1);
  }

  useEffect(() => {
    const month = new Date().getMonth();
    // console.log("month", month);
    const timer = setTimeout(() => {
      if (
        leftCalenderRef &&
        leftCalenderRef.current &&
        rightCalenderRef &&
        rightCalenderRef.current
      ) {
        // console.log("leftCalenderRef", leftCalenderRef);
        leftCalenderRef?.current.set("month", month);
        rightCalenderRef?.current.set("month", month + 1);
      }
    }, 10);
    return () => clearTimeout(timer);
  }, [calenderOpen]);

  return (
    <>
      <Box className="simple_pop_calendar">
        <button
          ref={ref}
          className={`calendar_main_clickbt calendar_main_clickbt_small ${
            !calenderFilter && "calender_active"
          }`}
          onClick={handleclicker}
        >
          {/* <img src={calendarIcons} alt="" /> */}
          <ComCalenderIcon />
        </button>
        {calenderOpen ? (
          <Box
            className="simple_pop_calendar_inner"
            onClick={handleButtonClick}
          >
            <Box className="calenderDate_Month">
              <Box className="calendar_inner_wraps">
                <Box className="calendar_outer_wraps">
                  <Calendar
                    ref={leftCalenderRef}
                    monthYearSeparator={<></>}
                    value={values}
                    months={months}
                    maxDate={maxDateLeft}
                    onMonthChange={(e) => {
                      // console.log("e", e);
                      // update("month", -1);
                      minusDateLeft(e.month);
                    }}
                    renderButton={(direction, handleClick) => (
                      <Button onClick={handleClick}>
                        {direction === "right" ? <CalenderArrowNext/> : <CalenderArrowPrev/>}
                      </Button>
                    )}
                    onChange={(e) => {
                      setValues(e);
                      setCalValues([
                        dayjs(
                          convert(e[0]?.toDate?.().toString()),
                          "YYYY-MM-DD"
                        ),
                        dayjs(
                          convert(e[1]?.toDate?.().toString()),
                          "YYYY-MM-DD"
                        ),
                      ]);
                    }}
                    range
                  />
                  <Calendar
                    value={values}
                    onMonthChange={(e) => {
                      // console.log("e", e);
                      // update("month", -1);
                      minusDateRight(e.month);
                    }}
                    ref={rightCalenderRef}
                    months={months}
                    monthYearSeparator={<></>}
                    maxDate={new Date()}
                    renderButton={(direction, handleClick) => (
                      <Button onClick={handleClick}>
                        {direction === "right" ? <CalenderArrowNext/> : <CalenderArrowPrev/>}
                      </Button>
                    )}
                    onChange={(e) => {
                      setValues(e);
                      setCalValues([
                        dayjs(
                          convert(e[0]?.toDate?.().toString()),
                          "YYYY-MM-DD"
                        ),
                        dayjs(
                          convert(e[1]?.toDate?.().toString()),
                          "YYYY-MM-DD"
                        ),
                      ]);
                    }}
                    range
                  />
                </Box>
              </Box>
              <Box className="calederButton">
                <button
                  onClick={() => {
                    setValues([null, null]);
                    setCalValues([null, null]);
                    calenderClose(false);
                  }}
                  className="cancel_btn"
                >
                  Cancel
                </button>
                <button
                  disabled={!calValues[0] && !calValues[1]}
                  onClick={() => {
                    confirmCalender(calValues);
                    setValues([null, null]);
                    setCalValues([null, null]);
                    calenderClose(false);
                    dispatch(setCheck(true));
                  }}
                  className="confrms_btn"
                >
                  Confirm
                </button>
              </Box>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </>
  );
};

export default CalenderDateThree;
